// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"56d23baa","262":"40edee80","362":"6196957c","736":"1a1b8402"}[chunkId] + ".chunk.js";
};